import React from 'react';
import styles from './styles.module.scss';
import { BaseEditModal } from 'components';
import { DocumentTextIcon } from 'assets';

interface StartAssessmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  // handleDetailsConfirmation: () => void;
  isLoading?: boolean;
}

export const StartAssessmentModal: React.FC<StartAssessmentModalProps> = ({
  isOpen,
  onClose,
  onSave,
  // handleDetailsConfirmation,
  isLoading
}) => {

  return (
    <BaseEditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Start Assessment"
      onSubmit={onSave}
      isSubmitting={isLoading}
      cancelButtonText=''
      saveButtonText='Start Assessment'
      footerClassName={styles.footer}
      contentClassName={styles.modalContainer}
      cvType={true}
      // onSwitch={handleDetailsConfirmation}
    >
      <div className={styles.modalContent}>
        <div className={styles.icon}>
          <DocumentTextIcon/>
        </div>
        <h4 className={styles.header}>
          Start timer?
        </h4>
        <p className={styles.text}>
          You have <b>60 minutes</b> to complete this assessment. Exiting your browser will automatically submit your assessment. The assessment will also be submitted automatically when time runs out.
        </p>
      </div>
    </BaseEditModal>
  );
};